import React from "react";
import loadingif from "../assets/loading-gif.gif";

export default function LoadingSpinners() {
    return (
        <div className="spinner-containers">
            <img src={loadingif} alt={loadingif} />
        </div>
    );
}